export enum LevelDatumAnchor {
  /**
   * @deprecated
   * this is a bad datum anchor, it should be removed
   * Levels do not have a bottom of floorplate
   * It does not account for slabs or varying floorplate thickness.
   */
  LEVEL_BOTTOM_OF_FLOOR_PLATE = "LEVEL_BOTTOM_OF_FLOOR_PLATE",
  LEVEL_TOP_OF_WALL = "LEVEL_TOP_OF_WALL",
  LEVEL_WINDOW_HEAD_HEIGHT = "LEVEL_WINDOW_HEAD_HEIGHT",
  LEVEL_FLOOR_ELEVATION = "LEVEL_FLOOR_ELEVATION",
  LEVEL_GRADE = "LEVEL_GRADE",
}

/**
 * @TODO - these datums should be renamed or replaced with the
 * appropriate LevelDatumAnchor or future RoomDatumAnchor values.
 *
 * Not doing this now because we don't quite know which room datums
 * will need to be supported
 */
export enum FoundationDatumVerticalAnchor {
  /**
   * @deprecated - should be replaced with LevelDatumAnchor.LEVEL_FLOOR_ELEVATION
   * Datum usage should be replaced with LegacyLevelDatumEntity
   * and this anchor should be deleted
   */
  LEVEL_FLOOR_ELEVATION = "LEVEL_FLOOR_ELEVATION",
  /**
   * @deprecated - should be replaced with LevelDatumAnchor.LEVEL_TOP_OF_WALL
   * Datum usage should be replaced with LegacyLevelDatumEntity
   * and this anchor should be deleted
   */
  LEVEL_TOP_OF_WALL = "LEVEL_TOP_OF_WALL",

  // --- BELOW THIS LINE ARE FOUNDATION SPECIFIC ANCHORS ---

  TOP_OF_SLAB = "TOP_OF_SLAB",
  BOTTOM_OF_SLAB = "BOTTOM_OF_SLAB",
  BOTTOM_OF_FLOORPLATE = "BOTTOM_OF_FLOORPLATE",
  FOUNDATION = "FOUNDATION",
}

export enum WallLateralDatumAnchor {
  OUTSIDE_FACE_OF_FRAMING = "OUTSIDE_FACE_OF_FRAMING",
  OUTSIDE_FACE_OF_SUBSTRATE = "OUTSIDE_FACE_OF_SUBSTRATE",
}

export enum WallHorizontalDatum {
  ROOM_EDGE = "ROOM_EDGE",
  STRUCTURE = "STRUCTURE",
  SUBSTRATE = "SUBSTRATE",
  OUTSIDE_OF_SURFACE = "OUTSIDE_OF_SURFACE",
}

export enum WallVerticalDatumAnchor {
  BASE_WALL = "BASE_WALL",
  GABLE_END = "GABLE_END",
}

export enum VerticalJustification {
  BOTTOM_UP = "BOTTOM_UP",
  TOP_DOWN = "TOP_DOWN",
}

export enum HorizontalJustification {
  START_TO_END = "START_TO_END",
  END_TO_START = "END_TO_START",
}

export enum LateralDatumJustification {
  INSIDE_TO_OUTSIDE = "INSIDE_TO_OUTSIDE",
  OUTSIDE_TO_INSIDE = "OUTSIDE_TO_INSIDE",
}

export enum VerticalDatumType {
  ABSOLUTE = "ABSOLUTE",
  RELATIVE = "RELATIVE",
}

export enum RelativeVerticalDatum {
  // TOP_OF_HOST = "TOP_OF_HOST",
  // BOTTOM_OF_HOST = "BOTTOM_OF_HOST",
  // TOP_PLATE_OF_HOST = "TOP_PLATE_OF_HOST",
  // BOTTOM_PLATE_OF_HOST = "BOTTOM_PLATE_OF_HOST",
  // TOP_OF_LEVEL_ABOVE_HOST = "TOP_OF_LEVEL_ABOVE_HOST",
  // BOTTOM_OF_LEVEL_BELOW_HOST = "BOTTOM_OF_LEVEL_BELOW_HOST",
  // TOP_PLATE_LEVEL_ABOVE_HOST = "TOP_PLATE_LEVEL_ABOVE_HOST",
  // BOTTOM_PLATE_LEVEL_BELOW_HOST = "BOTTOM_PLATE_LEVEL_BELOW_HOST",
  TOP_OF_FF_HOST = "TOP_OF_FF_HOST",
  TOP_OF_WALL_PLATE_HOST = "TOP_OF_WALL_PLATE_HOST",
  TOP_OF_FF_ABOVE_HOST = "TOP_OF_FF_ABOVE_HOST",
  TOP_OF_WALL_PLATE_ABOVE_HOST = "TOP_OF_WALL_PLATE_ABOVE_HOST",
  TOP_OF_FF_FINISH_BELOW_HOST = "TOP_OF_FF_FINISH_BELOW_HOST",
  TOP_OF_WALL_PLATE_BELOW_HOST = "TOP_OF_WALL_PLATE_BELOW_HOST",
  STAIR_SYSTEM = "STAIR_SYSTEM",
  BOTTOM_OF_STAIR_SYSTEM_HOST = "BOTTOM_OF_STAIR_SYSTEM_HOST",
}

// TODO - below this line are PropInstance specific datums
// Which do not officially use the DatumAbstraction (yet), but we should keep them here
// So we don't lose them

/**
 * @deprecated - should be replaced with LevelDatums and AbsoluteDatums
 */
export enum PropInstanceVerticalDatumAnchor {
  LEVEL_FLOOR_ELEVATION = "LEVEL_FLOOR_ELEVATION",
  LEVEL_GRADE = "LEVEL_GRADE",
  /**
   * @TODO - this datum might warrant a new RoomDatumAnchor.ROOM_FLOOR_ELEVATION
   * and a new set of LegacyVerticalDatums to support it. although
   * preference should be to use LevelDatums and AbsoluteDatums instead.
   */
  ROOM_FLOOR_ELEVATION = "ROOM_FLOOR_ELEVATION",
}

export enum PropInstanceHorizontalAlignment {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
  ORIGIN = "ORIGIN",
}

export enum PropInstanceLateralAlignment {
  OUTSIDE_FACE = "OUTSIDE_FACE",
  CENTERLINE = "CENTERLINE",
  INSIDE_FACE = "INSIDE_FACE",
  ORIGIN = "ORIGIN",
}

export enum PropInstanceVerticalAlignment {
  TOP = "TOP",
  CENTER = "CENTER",
  BOTTOM = "BOTTOM",
  ORIGIN = "ORIGIN",
}

// TODO - below this line are Casework specific datums
// Which do not officially use the DatumAbstraction (yet), but we should keep them here
// So we don't lose them

/**
 * @deprecated - should be replaced with LevelDatums and AbsoluteDatums
 */
export enum CaseworkVerticalDatumAnchor {
  LEVEL_FLOOR_ELEVATION = "LEVEL_FLOOR_ELEVATION",
  LEVEL_GRADE = "LEVEL_GRADE",
  LEVEL_CEILING_HEIGHT = "LEVEL_CEILING_HEIGHT",
  ROOM_FLOOR_ELEVATION = "ROOM_FLOOR_ELEVATION",
}

export enum CaseworkVerticalAlignment {
  TOP = "TOP",
  CENTER = "CENTER",
  BOTTOM = "BOTTOM",
}

export enum CaseworkHorizontalAlignment {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export enum CaseworkLateralAlignment {
  OUTSIDE_FACE = "OUTSIDE_FACE",
  CENTERLINE = "CENTERLINE",
  INSIDE_FACE = "INSIDE_FACE",
}
